var offsetxpoint=10;
var offsetypoint=10;
var enabletip=false;
var timeoutObj;
var timeoutObj2;
var currentHtml;
var tipobj = null;
var useXmlObj;
var stopper = false;

function ieqtruebody()
{
	return (document.compatMode && document.compatMode!="BackCompat")? document.documentElement : document.body
}

function dquicktip(thetext, thecolor, thewidth)
{
	if (typeof thewidth!="undefined") tipobj.style.width=thewidth+"px";
	if (typeof thecolor!="undefined" && thecolor!="") tipobj.style.backgroundColor=thecolor;

	updateQHtml(thetext);
	enabletip=true;

	var rightedge=luvit.browserIsIE()&&!window.opera? ieqtruebody().clientWidth-tempX-offsetxpoint : window.innerWidth-tempX-offsetxpoint-20;
	var bottomedge=luvit.browserIsIE()&&!window.opera? ieqtruebody().clientHeight-tempY-offsetypoint : window.innerHeight-tempY-offsetypoint-20;
	var leftedge = (offsetxpoint < 0) ? offsetxpoint * (-1) : -1000;

	
	tipobj.style.left=tempX+offsetxpoint+"px";
	tipobj.style.top=tempY+offsetypoint+"px";
}

function dquicktippos(thetext,x,y) {

    updateQHtml(thetext);
    
    tipobj.style.left= (x - 2) + "px";
    tipobj.style.top= (y - 2) + "px";	
}

function updateQHtml(thetext)
{
	if(!useXmlObj)
	{
		tipobj.innerHTML = "";
		tipobj.style.visibility="hidden";
	}
	else
	{
		getQTT(thetext);
	}	
}

function getQTT()
{
	if(!xmlhttp || xmlhttp==null)
		return;
	if(callQInProgress())
		return;
	
	myRandom=parseInt(Math.random()*99999999);
	myUrl = xmlQUrl + "?random=" + myRandom + "&id=" + getQTT.arguments[0];
	if(getQTT.arguments.length>1)
	{
		for(i=1;i<getQTT.arguments.length;i++)
		{
			myUrl += "&arg" + (i+1) + "=" + getQTT.arguments[i];
		}
		alert(myUrl);
	}
	xmlhttp.open("GET", myUrl, true);
	xmlhttp.onreadystatechange=function()
	{
		if (xmlhttp.readyState==4)
		{
			if(xmlhttp.status!=200)
			{
				return;
			}
			else
			{
				if(xmlhttp.responseText.indexOf("<html>") == -1 && xmlhttp.responseText.indexOf("<html>") == -1)
				{
					tipobj.innerHTML = xmlhttp.responseText;
					tipobj.style.visibility="visible";
				}
			}
		}
	}
	xmlhttp.send(null);
}

window.hidedquicktip = function()
{
    clearTimeout(timeoutObj2);
    clearTimeout(timeoutObj);

    if(timeoutObj != null)
        timeoutObj2 = setTimeout("hidedquicktip2()",1000);
}

function hidedquicktip2()
{
    if(stopper)
    {
        return;
    }

	document.onmousemove = null;
	clearTimeout(timeoutObj);
	if(tipobj==null)return;
	enabletip=false;
	tipobj.style.visibility="hidden";
	tipobj.style.backgroundColor="";
	tipobj.style.width="";
	clearTimeout(timeoutObj2);
}

function init_dquicktip(thetext,useXmlRequest) {
    
    clearTimeout(timeoutObj2);
    clearTimeout(timeoutObj);
    
	document.onmousemove = getMouseXY;
	
	useXmlObj = useXmlRequest;
	tipobj = document.getElementById("dhtmltooltip");
	if(tipobj==null)
	{
		return;
	}
	
	if (luvit.browserIsIE())
	{
	    tipobj.onmouseover = handleOnMouseOver;
	    tipobj.onmouseleave = handleOnMouseOut;
	}
	
	timeoutObj = setTimeout("dquicktip('" + thetext.replace("'","&#39;") + "')",1000);	

}

window.init_dquicktippos = function(thetext, useXmlRequest, x, y) {


    document.onmousemove = getMouseXY;

    useXmlObj = useXmlRequest;
    tipobj = document.getElementById("dhtmltooltip");
    
    if (tipobj == null) {
        return;
    }
    $(tipobj).mouseleave(function(e) {
        handleOnMouseOut(e);
    });

    dquicktippos(thetext.replace("'", "&#39;"), x, y);

}

function handleOnMouseOver()
{
    stopper = true;
}

function handleOnMouseOut(evt) {

    stopper = false;
    
    hidedquicktip2();
}

if (!luvit.browserIsIE()) document.captureEvents(Event.MOUSEMOVE);
var tempX = 0;
var tempY = 0;
function getMouseXY(e) 
{
	if (luvit.browserIsIE())
	{ 
		tempX = event.clientX + document.body.scrollLeft;
		tempY = event.clientY + document.body.scrollTop;
	}
	else 
	{  
		tempX = e.pageX;
		tempY = e.pageY;
	}  
	if (tempX < 0){tempX = 0;}
	if (tempY < 0){tempY = 0;}  
	return true;
}

function callQInProgress() 
{
    switch (xmlhttp.readyState) 
    {
        case 1:
            return true;
			break;
		case 2:
            return true;
			break;
		case 3:
            return true;
			break;
        default:
            return false;
			break;
    }
}